export const QUOTE_CATEGORY_TYPE = {
  GREIGE: 1,
  JOB_WORK: 2,
  BUNDLED: 3,
  YARN_DYED: 4,
  DENIM: 5,
};

export const PRODUCTION_SUB_TYPE = {
  Greige: 1,
  YarnDyed: 2,
  Rfd: 3,
  Dyed: 4,
  Printed: 5,
  Denim: 6
};

export const QUOTE_SUBMISSION_TYPE = {
  XFactory: 1,
  Landed: 2,
  Fob: 3,
  Cnf: 4,
};
  
export const QUOTE_CATEGORY_TYPE_REVERSE = {
  [QUOTE_CATEGORY_TYPE.BUNDLED]: 'Bundled',
  [QUOTE_CATEGORY_TYPE.JOB_WORK]: 'Job work',
  [QUOTE_CATEGORY_TYPE.GREIGE]: 'Greige',
  [QUOTE_CATEGORY_TYPE.YARN_DYED]: 'Yarn dyed',
  [QUOTE_CATEGORY_TYPE.DENIM]: 'Denim',
};

export const QUOTE_SUBMISSION_TYPE_REVERSE = {
  [QUOTE_SUBMISSION_TYPE.XFactory]: 'x-factory',
  [QUOTE_SUBMISSION_TYPE.Landed]: 'Landed',
  [QUOTE_SUBMISSION_TYPE.Fob]: 'FOB',
  [QUOTE_SUBMISSION_TYPE.Cnf]: 'CNF',
};

export const AGENT_SAMPLE_STATUS = {
  AWAITING_PAYMENT: 5,
  REQUESTED: 10,
  DISPATCHED: 15,
  DELIVERED: 20,
  FEEDBACK_RECEIVED: 25,
  REJECTED_BEFORE_DELIVERY: 100,
};

export const AGENT_SAMPLE_STATUS_REVERSE: Record<number, string> = {
  [AGENT_SAMPLE_STATUS.AWAITING_PAYMENT]: 'Sample payment awaiting',
  [AGENT_SAMPLE_STATUS.REQUESTED]: 'Sample requested',
  [AGENT_SAMPLE_STATUS.DISPATCHED]: 'Sample dispatched',
  [AGENT_SAMPLE_STATUS.DELIVERED]: 'Sample delivered',
  [AGENT_SAMPLE_STATUS.FEEDBACK_RECEIVED]: 'Feedback received',
  [AGENT_SAMPLE_STATUS.REJECTED_BEFORE_DELIVERY]: 'Sample rejected',
};

export const AGENT_SAMPLE_STATUS_CLASS: Record<number, string> = {
  [AGENT_SAMPLE_STATUS.AWAITING_PAYMENT]: 'orangeText',
  [AGENT_SAMPLE_STATUS.REQUESTED]: 'blueText',
  [AGENT_SAMPLE_STATUS.DISPATCHED]: 'violetText',
  [AGENT_SAMPLE_STATUS.DELIVERED]: 'successText',
  [AGENT_SAMPLE_STATUS.FEEDBACK_RECEIVED]: 'successText',
  [AGENT_SAMPLE_STATUS.REJECTED_BEFORE_DELIVERY]: 'redText',
};

export const getAgentSampleChip = (
  agentSampleStatus: number,
  isAgentSampleRejected: boolean
): { label: string; className: string } => {
  const status = isAgentSampleRejected
    ? AGENT_SAMPLE_STATUS.REJECTED_BEFORE_DELIVERY
    : agentSampleStatus;

  return {
    label: AGENT_SAMPLE_STATUS_REVERSE[status],
    className: AGENT_SAMPLE_STATUS_CLASS[status],
  };
};

export const USER_PRODUCTION_TYPE = {
  GREIGE: 1,
  FINISHED_FABRIC: 2,
  DENIM: 3,
};